// SUPER-LOT 131 — Tri WYSIWYG réutilisable pour toutes les tables de l'onglet CASH RJ.
import { useState } from "react";
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";

export function useSort(defaultKey = null, defaultDir = "asc") {
    const [sort, setSort] = useState({ key: defaultKey, dir: defaultDir });
    const toggle = (key) => setSort((s) => (s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" }));
    return [sort, toggle];
}

// Tri stable : renvoie une COPIE triée selon l'accesseur de la colonne active (nombres numériques, sinon localeCompare FR).
export function sortRows(rows, sort, accessors) {
    if (!sort?.key || !accessors[sort.key]) return rows;
    const acc = accessors[sort.key];
    const out = [...(rows || [])].sort((a, b) => {
        const va = acc(a), vb = acc(b);
        if (typeof va === "number" && typeof vb === "number") return va - vb;
        return String(va ?? "").localeCompare(String(vb ?? ""), "fr", { numeric: true, sensitivity: "base" });
    });
    return sort.dir === "desc" ? out.reverse() : out;
}

export function SortTh({ label, sortKey, sort, onToggle, align = "left", className = "", testid }) {
    const active = sort?.key === sortKey;
    const Icon = !active ? ChevronsUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
    return (
        <th className={`py-2 ${className}`}>
            <button type="button" data-testid={testid} onClick={() => onToggle(sortKey)}
                className={`flex items-center gap-1 select-none transition-colors hover:text-indigo-600 ${active ? "text-indigo-600" : ""} ${align === "right" ? "justify-end ml-auto" : ""}`}>
                <span>{label}</span>
                <Icon className="h-3 w-3 shrink-0" strokeWidth={2} />
            </button>
        </th>
    );
}
